import packageInfo from '../package.json';

// Detección de entorno
export const isDev = process.env.REACT_APP_PRODUCTION === 'false';

// URLs de la API
export const songsAPIUrl = 'https://playermiddleware.voxpopaudio.com';
export const clsAPIurl = isDev
	? 'http://10.112.2.187:3010/player-v2'
	: 'https://cls-api.voxpop.com.mx/player';

// Función para obtener el umbral de seguimiento
export function getTrackingThreshold() {
	return 1000 * 60; // 1 minuto en milisegundos
}

// Determinar el tipo de reproductor (basado en el user agent)
const userAgent = window.navigator.userAgent.toLowerCase();
export const player_type = userAgent.indexOf(' electron/') > -1 ? 'desktop' : 'web';

// Versión del paquete desde package.json
export const package_version = packageInfo.version;

/**
 * Retorna el ID del computador/escritorio.
 * Este ID se obtiene asincrónicamente del proceso principal de Electron
 * si la aplicación se está ejecutando en un entorno de escritorio.
 * Si no es una aplicación de escritorio, la función no hará nada.
 *
 * @returns {Promise<string>} Una promesa que resuelve con el ID del computador o una cadena vacía.
 */
export async function getDesktopId() {
	// Solo intenta obtener el ID si la API de Electron está disponible y la app es de escritorio
	if (player_type === 'desktop' && window.electronAPI && window.electronAPI.getDesktopId) {
		try {
			return await window.electronAPI.getDesktopId();
		} catch (error) {
			console.error('Error al obtener el ID del escritorio de Electron:', error);
			return '';
		}
	}
	return '';
}